import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from './home/home'

const Articles = () => {
  return (
    <Routes>
        <Route path="*" element={<Home />}/>
    </Routes>
  )
}

export default Articles